/* ============================================================
   THE RV PART STORE — theme.js
   Mega nav · mobile menu · AJAX cart + drawer
   ============================================================ */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var value = (cents / 100.0).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, value)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toLocaleString('en-CA'));
  }

  /* ============================================================
     MEGA NAV (hover)
     ============================================================ */
  function initMegaNav() {
    var nav = $('[data-mega-nav]');
    if (!nav) return;
    var timer = null;
    function closeAll() { $$('[data-mega-panel]', nav).forEach(function (p) { p.hidden = true; }); $$('.navlink', nav).forEach(function (l) { l.classList.remove('is-open'); }); }
    $$('[data-mega-item]', nav).forEach(function (item) {
      var panel = $('[data-mega-panel]', item);
      var link = $('.navlink', item);
      if (!panel) return;
      item.addEventListener('mouseenter', function () { clearTimeout(timer); closeAll(); panel.hidden = false; link.classList.add('is-open'); });
      item.addEventListener('mouseleave', function () { timer = setTimeout(closeAll, 140); });
      panel.addEventListener('mouseenter', function () { clearTimeout(timer); });
      panel.addEventListener('mouseleave', function () { timer = setTimeout(closeAll, 140); });
    });
    nav.addEventListener('mouseleave', function () { timer = setTimeout(closeAll, 140); });
  }

  /* ============================================================
     MOBILE MENU
     ============================================================ */
  function show(el) { if (el) el.hidden = false; }
  function hide(el) { if (el) el.hidden = true; }

  function closeAllOverlays() {
    hide($('[data-mobile-menu]')); hide($('[data-menu-scrim]'));
    closeCartDrawer();
  }

  function initOverlays() {
    var burger = $('[data-open-menu]'), mm = $('[data-mobile-menu]'), mScrim = $('[data-menu-scrim]');
    if (burger) burger.addEventListener('click', function () { show(mm); show(mScrim); });
    $$('[data-close-menu]').forEach(function (b) { b.addEventListener('click', function () { hide(mm); hide(mScrim); }); });
    if (mScrim) mScrim.addEventListener('click', function () { hide(mm); hide(mScrim); });

    $$('[data-mm-toggle]').forEach(function (btn) {
      function toggle() {
        var subs = btn.closest('.mm-group').querySelector('.mm-subs');
        if (!subs) return;
        subs.hidden = !subs.hidden;
        btn.setAttribute('aria-expanded', subs.hidden ? 'false' : 'true');
        var ic = btn.querySelector('svg'); if (ic) ic.style.transform = subs.hidden ? '' : 'rotate(180deg)';
      }
      btn.addEventListener('click', toggle);
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });

    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAllOverlays(); });
  }

  /* ============================================================
     QTY STEPPERS
     ============================================================ */
  function initQty() {
    $$('[data-qty]').forEach(function (q) {
      var input = $('[data-qty-input]', q) || $('input', q);
      var span = $('[data-qty-value]', q);
      $$('[data-qty-minus]', q).forEach(function (b) { b.addEventListener('click', function () { setVal(getVal() - 1); }); });
      $$('[data-qty-plus]', q).forEach(function (b) { b.addEventListener('click', function () { setVal(getVal() + 1); }); });
      function getVal() { return parseInt((input && input.value) || (span && span.textContent) || '1', 10) || 1; }
      function setVal(n) { n = Math.max(1, n); if (input) input.value = n; if (span) span.textContent = n; }
    });
  }

  /* ============================================================
     AJAX CART
     ============================================================ */
  function addToCart(variantId, qty) {
    qty = qty || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    }).then(function (r) { return r.json(); }).then(function (item) {
      return refreshCart().then(function (cart) {
        return { item: item, cart: cart };
      });
    });
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); renderDrawer(cart); return cart; });
  }

  function updateCartCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }

  function initAddButtons() {
    // quick add (cards)
    $$('[data-quick-add]').forEach(function (btn) {
      if (btn.getAttribute('data-bound')) return;
      btn.setAttribute('data-bound', '1');
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        btn.disabled = true;
        addToCart(id, 1).then(function (res) {
          btn.classList.add('is-added');
          btn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5 9-11"/></svg> Added';
          toast((btn.getAttribute('data-product-title') || 'Item') + ' added to cart');
          openCartDrawer();
          setTimeout(function () {
            btn.classList.remove('is-added'); btn.disabled = false;
            btn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h2l2.4 12.3a1 1 0 0 0 1 .7h9.7a1 1 0 0 0 1-.8L21 7H6"/><circle cx="9.5" cy="20" r="1.3"/><circle cx="18" cy="20" r="1.3"/></svg> Quick add';
          }, 1400);
        }).catch(function () { btn.disabled = false; toast('Could not add to cart'); });
      });
    });

    // product form add
    var form = $('[data-product-form]') || document.getElementById('ProductForm');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var id = (form.querySelector('[name="id"]') || {}).value;
        var qtyEl = form.querySelector('[name="quantity"]');
        var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
        var submit = form.querySelector('[type="submit"]');
        if (submit) submit.disabled = true;
        addToCart(id, qty).then(function () {
          toast('Added to cart'); openCartDrawer();
          if (submit) { submit.disabled = false; submit.classList.add('is-added'); setTimeout(function () { submit.classList.remove('is-added'); }, 1600); }
        }).catch(function () { if (submit) submit.disabled = false; });
      });
    }
  }

  /* ---------- cart drawer ---------- */
  function openCartDrawer() {
    if (document.body.getAttribute('data-cart-type') === 'page') { window.location.href = '/cart'; return; }
    var d = $('[data-cart-drawer]'), s = $('[data-cart-drawer-scrim]');
    refreshCart().then(function () { show(d); show(s); document.body.style.overflow = 'hidden'; });
  }
  function closeCartDrawer() {
    var d = $('[data-cart-drawer]'), s = $('[data-cart-drawer-scrim]');
    hide(d); hide(s); document.body.style.overflow = '';
  }

  function renderDrawer(cart) {
    var body = $('[data-cart-drawer-body]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty" style="padding:60px 20px"><span class="cart-empty-ico"><svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 3h2l2.4 12.3a1 1 0 0 0 1 .7h9.7a1 1 0 0 0 1-.8L21 7H6"/><circle cx="9.5" cy="20" r="1.3"/><circle cx="18" cy="20" r="1.3"/></svg></span><h3 class="display" style="font-size:24px">YOUR CART IS EMPTY</h3></div>';
      var f = $('[data-cart-drawer-foot]'); if (f) f.hidden = true;
      return;
    }
    var html = '';
    html += '<div class="cart-ship-nudge is-won"><span><b>FREE shipping</b> to all Canadian provinces</span></div>';

    cart.items.forEach(function (it) {
      html += '<div class="cartline" data-line-key="' + it.key + '">';
      html += '<a class="cartline-media" href="' + it.url + '">' + (it.image ? '<img src="' + it.image + '" alt="" style="position:absolute;inset:0;width:100%;height:100%;object-fit:contain">' : '') + '</a>';
      html += '<div class="cartline-info"><span class="pcard-brand mono">' + (it.vendor || '') + '</span>';
      html += '<a class="cartline-name" href="' + it.url + '">' + it.product_title + '</a>';
      html += '<span class="cartline-sku mono">' + (it.sku ? 'SKU ' + it.sku : '') + '</span></div>';
      html += '<div class="cartline-right"><div class="qty qty-sm" data-line-qty><button data-line-minus aria-label="Decrease"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M5 12h14"/></svg></button><span class="mono">' + it.quantity + '</span><button data-line-plus aria-label="Increase"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M12 5v14"/><path d="M5 12h14"/></svg></button></div>';
      html += '<span class="cartline-price">' + formatMoney(it.final_line_price) + '</span>';
      html += '<button class="cartline-rm" data-line-remove aria-label="Remove"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16"/><path d="M9 7V5h6v2"/><path d="M6 7l1 13h10l1-13"/></svg></button></div></div>';
    });
    body.innerHTML = html;

    var sub = $('[data-cart-drawer-subtotal]'); if (sub) sub.textContent = formatMoney(cart.total_price);
    var f = $('[data-cart-drawer-foot]'); if (f) f.hidden = false;

    // line controls
    $$('[data-line-key]', body).forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var qEl = $('[data-line-qty] span', line);
      function change(n) { changeLine(key, n); }
      $('[data-line-minus]', line).addEventListener('click', function () { change(Math.max(0, parseInt(qEl.textContent, 10) - 1)); });
      $('[data-line-plus]', line).addEventListener('click', function () { change(parseInt(qEl.textContent, 10) + 1); });
      $('[data-line-remove]', line).addEventListener('click', function () { change(0); });
    });
  }

  function changeLine(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(cart.item_count); renderDrawer(cart);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    });
  }

  function initCartDrawer() {
    document.body.setAttribute('data-cart-type', (window.theme && window.theme.cartType) || document.body.getAttribute('data-cart-type') || 'drawer');
    $$('[data-cart-toggle]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        if (document.body.getAttribute('data-cart-type') === 'page') return; // let link work
        e.preventDefault(); openCartDrawer();
      });
    });
    $$('[data-cart-drawer-close]').forEach(function (b) { b.addEventListener('click', closeCartDrawer); });
    var s = $('[data-cart-drawer-scrim]'); if (s) s.addEventListener('click', closeCartDrawer);
  }

  /* ============================================================
     STICKY ADD-TO-CART (product page)
     ============================================================ */
  function initSticky() {
    var sticky = $('[data-pp-sticky]'); var buy = $('[data-pp-buy]');
    if (!sticky || !buy) return;
    function onScroll() {
      var r = buy.getBoundingClientRect();
      sticky.classList.toggle('is-on', r.bottom < 80);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ============================================================
     TOAST
     ============================================================ */
  function toast(msg) {
    var host = $('#ToastHost'); if (!host) return;
    var t = document.createElement('div');
    t.className = 'toast';
    t.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="var(--green)" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5 9-11"/></svg><span>' + msg + '</span><a class="toast-go" href="/cart">View cart</a>';
    host.appendChild(t);
    setTimeout(function () { t.style.opacity = '0'; t.style.transform = 'transl(-50%, 20px)'; }, 2400);
    setTimeout(function () { t.remove(); }, 2900);
  }
  window.tapToast = toast;
  window.tapInitCards = function () { initAddButtons(); };

  /* ============================================================
     FILTERS (mobile drawer on collection)
     ============================================================ */
  function initFilterDrawer() {
    var open = $('[data-open-filters]'), wrap = $('[data-filters]'), close = $('[data-close-filters]');
    if (open && wrap) open.addEventListener('click', function () { wrap.classList.add('is-open'); });
    if (close && wrap) close.addEventListener('click', function () { wrap.classList.remove('is-open'); });
  }

  /* ---------- cart page line controls ---------- */
  function initCartPage() {
    var page = $('[data-cart-page]');
    if (!page) return;
    $$('[data-line-key]', page).forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var qEl = $('[data-line-qty] span', line);
      function change(n) {
        fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: key, quantity: n })
        }).then(function (r) { return r.json(); }).then(function () { window.location.reload(); });
      }
      var minus = $('[data-line-minus]', line), plus = $('[data-line-plus]', line), rm = $('[data-line-remove]', line);
      if (minus) minus.addEventListener('click', function () { change(Math.max(0, parseInt(qEl.textContent, 10) - 1)); });
      if (plus) plus.addEventListener('click', function () { change(parseInt(qEl.textContent, 10) + 1); });
      if (rm) rm.addEventListener('click', function () { change(0); });
    });
  }

  /* ============================================================
     PREDICTIVE (LIVE) SEARCH
     ============================================================ */
  function initPredictiveSearch() {
    var base = (window.theme && window.theme.predictiveSearchUrl) || '/search/suggest';
    $$('[data-predictive-form]').forEach(function (form) {
      var input = $('[data-predictive-input]', form);
      var panel = $('[data-predictive-results]', form);
      if (!input || !panel) return;

      var timer = null, lastQ = '', controller = null;

      function close() {
        panel.hidden = true; panel.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
      }
      function openPanel() {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }
      function activeItems() { return $$('.psearch-item', panel); }
      function clearActive() { activeItems().forEach(function (a) { a.classList.remove('is-active'); }); }

      function run(q) {
        if (controller) controller.abort();
        controller = (typeof AbortController !== 'undefined') ? new AbortController() : null;
        var url = base + '?q=' + encodeURIComponent(q) +
                  '&section_id=predictive-search' +
                  '&resources[type]=product&resources[limit]=6';
        fetch(url, { signal: controller && controller.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            // Ignore stale responses if the box was cleared meanwhile.
            if (input.value.trim().length < 2) { close(); return; }
            panel.innerHTML = html;
            openPanel();
          })
          .catch(function (e) { if (!e || e.name !== 'AbortError') close(); });
      }

      input.addEventListener('input', function () {
        var q = input.value.trim();
        clearTimeout(timer);
        if (q.length < 2) { lastQ = ''; close(); return; }
        if (q === lastQ) return;
        timer = setTimeout(function () { lastQ = q; run(q); }, 200);
      });

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2 && panel.innerHTML) openPanel();
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { close(); return; }
        if (panel.hidden) return;
        var items = activeItems();
        if (!items.length) return;
        var idx = items.indexOf(document.querySelector('.psearch-item.is-active'));
        if (e.key === 'ArrowDown') {
          e.preventDefault(); clearActive();
          items[Math.min(items.length - 1, idx + 1)].classList.add('is-active');
        } else if (e.key === 'ArrowUp') {
          e.preventDefault(); clearActive();
          items[Math.max(0, idx <= 0 ? 0 : idx - 1)].classList.add('is-active');
        } else if (e.key === 'Enter') {
          var active = document.querySelector('.psearch-item.is-active');
          if (active) { e.preventDefault(); window.location.href = active.getAttribute('href'); }
        }
      });

      document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    });
  }

  /* ============================================================
     BRAND MARQUEE (clones the cards client-side so the server HTML lists each brand once)
     ============================================================ */
  function initBrandMarquee(root) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    $$('.brand-track', root || document).forEach(function (track) {
      if (track.getAttribute('data-looped')) return;
      var cards = Array.prototype.slice.call(track.children);
      cards.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('tabindex', '-1');
        Array.prototype.slice.call(clone.attributes).forEach(function (attr) {
          if (attr.name.indexOf('data-shopify') === 0) clone.removeAttribute(attr.name);
        });
        track.appendChild(clone);
      });
      track.setAttribute('data-looped', '1');
      track.classList.add('is-looping');
      if (track.parentNode && track.parentNode.classList) track.parentNode.classList.add('is-looping');
    });
  }

  /* ---------- boot ---------- */
  function init() {
    initMegaNav();
    initOverlays();
    initQty();
    initAddButtons();
    initCartDrawer();
    initFilterDrawer();
    initCartPage();
    initSticky();
    initPredictiveSearch();
    initBrandMarquee();
  }
  document.addEventListener('shopify:section:load', function (e) { initBrandMarquee(e.target); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
